//Este watcher tiene un flujo con logica definida, si no cubre tus necesidades, recrea uno que si lo haga

export default {
  watch: {
    'filters.academicYear': function() {
      this.resetByAcademicYear();
      this.getRegions();
    },
    'filters.region': function() {
      this.resetByRegion();
      this.getMunicipalitiesByRegion();

      let municipalities = this.collections.municipalities;

      if (
        municipalities != null &&
        municipalities.length == 1 &&
        municipalities[0].selected
      ) {
        this.filters.municipality = municipalities[0];
        this.municipalityDisabled = true;
      } else {
        this.municipalityDisabled = false;
      }
    },
    'filters.municipality': function() {
      this.resetByMunicipality();
      this.getSchools();

      let schools = this.collections.schools;

      if (schools != null && schools.length == 1 && schools[0].selected) {
        this.filters.school = schools[0];
        this.schoolDisabled = true;
      } else {
        this.schoolDisabled = false;
      }
    },
  },
};
